import { getAxiosInstance } from "../ApiConfig";

async function getCompanyInvoice() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllInvoiceByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllInvoice(page, limit, search) {
    try {
        let url = `/usermgmt/fetchAllInvoiceByReportingRoleUsers`;
        if (page && limit) {
            url += `?page=${page}&limit=${limit}`;
            if (search) url += `&search=${search}`;
        }
        const response = await getAxiosInstance().get(url);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllInvoicePaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllInvoiceByReportingRoleUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllInvoiceSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllInvoiceByReportingRoleUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchInvoiceByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllInvoiceByDealId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findOneByInvoice(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByInvoice/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteInvoice(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteInvoice/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createInvoice(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createInvoice`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateInvoice(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateInvoice/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    getCompanyInvoice,
    FetchInvoiceByDeal,
    fetchAllInvoice,
    findOneByInvoice,
    deleteInvoice,
    updateInvoice,
    createInvoice,
    AllInvoicePaginationSearch,
    AllInvoiceSearch,
}